// extracted by mini-css-extract-plugin
export default {"container":"filterBreadcrumbs-container__wCjim","filterNameTag":"filterBreadcrumbs-filterNameTag__Kd9ca"};